import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PATTERN_NUMERIC, SMS_DEFAULT_REGISTRATION_SUCCESS, SMS_DEFAULT_USER_ALREADY_REGISTERED, SMS_DEFAULT_ANOTHER_USER_REGISTERED, SMS_DEFAULT_USER_MAXED_COUPON, SMS_PRICE } from "src/app/utils/constant";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { CampaignMaintenanceService } from "../campaign-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as moment from "moment";
import * as _ from "lodash";

@Component({
  selector: "esc-campaign-maintenance-form",
  templateUrl: "./campaign-maintenance-form.component.html",
  styleUrls: ["./campaign-maintenance-form.component.scss"]
})
export class CampaignMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  loading = {
    submit: false
  };
  private defaultSMSMessages = [
    {
      type: "REGISTRATION_SUCCESS",
      message: SMS_DEFAULT_REGISTRATION_SUCCESS
    },
    {
      type: "USER_ALREADY_REGISTERED",
      message: SMS_DEFAULT_USER_ALREADY_REGISTERED
    },
    {
      type: "ANOTHER_USER_REGISTERED",
      message: SMS_DEFAULT_ANOTHER_USER_REGISTERED
    },
    {
      type: "USER_MAXED_COUPON",
      message: SMS_DEFAULT_USER_MAXED_COUPON
    },
  ]

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    public cmpMntService: CampaignMaintenanceService
  ) { }

  public minDate = new Date(moment().add(1, 'd').toDate());
  public existingMinDate = null;
  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
    console.log(this.detail);
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: _.get(this.detail, "code"),

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(250)]],

      reference_filename: [_.get(this.detail, "reference_filename"), [Validators.required]],

      start_date: [_.has(this.detail, "start_date") ? new Date(this.detail.start_date) : null, [Validators.required]],

      end_date: [_.has(this.detail, "end_date") ? new Date(this.detail.end_date) : null, [Validators.required]],

      reversal_number_of_days: [_.get(this.detail, "reversal_number_of_days"), [Validators.required, Validators.maxLength(3), Validators.min(1), Validators.pattern(PATTERN_NUMERIC)]],

      registration_success: [this.getSmsMessage(_.get(this.detail, 'campaign_sms_message'), "registration_success"), [Validators.required]],

      user_already_registered: [this.getSmsMessage(_.get(this.detail, 'campaign_sms_message'), "user_already_registered"), [Validators.required]],

      another_user_registered: [this.getSmsMessage(_.get(this.detail, 'campaign_sms_message'), "another_user_registered"), [Validators.required]],

      user_maxed_coupon: [this.getSmsMessage(_.get(this.detail, 'campaign_sms_message'), "user_maxed_coupon"), [Validators.required]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  datepickerOpened() {
    this.existingMinDate = new Date(moment().add(1, 'd').toDate());
  }

  datepickerClosed() {
    this.existingMinDate = null;
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
    } else {
      this.formGroup.get("description").disable({ emitEvent: false });
    }

    //always disabled since 'code' is auto-populated
    this.formGroup.get("code").disable({ emitEvent: false });
  }

  isFormValid() {
    if (this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if (!this.formGroup.controls[ctrl].valid) {
          this[ctrl + "Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          reference_filename: _.get(this.formGroup.get("reference_filename"), "value"),

          start_date: moment(_.get(this.formGroup.get("start_date"), "value")).format("YYYY-MM-DD 00:00:00"),

          end_date: moment(_.get(this.formGroup.get("end_date"), "value")).format("YYYY-MM-DD 23:59:59"),

          reversal_number_of_days: parseInt(_.get(this.formGroup.get("reversal_number_of_days"), "value")),

          campaign_sms_message: [
            {
              id: this.getSmsId(_.get(this.detail, 'campaign_sms_message'), "registration_success"),
              type: _.get(this.defaultSMSMessages[0], "type"),
              message: _.get(this.formGroup.get("registration_success"), "value")
            },
            {
              id: this.getSmsId(_.get(this.detail, 'campaign_sms_message'), "user_already_registered"),
              type: _.get(this.defaultSMSMessages[1], "type"),
              message: _.get(this.formGroup.get("user_already_registered"), "value")
            },
            {
              id: this.getSmsId(_.get(this.detail, 'campaign_sms_message'), "another_user_registered"),
              type: _.get(this.defaultSMSMessages[2], "type"),
              message: _.get(this.formGroup.get("another_user_registered"), "value")
            },
            {
              id: this.getSmsId(_.get(this.detail, 'campaign_sms_message'), "user_maxed_coupon"),
              type: _.get(this.defaultSMSMessages[3], "type"),
              message: _.get(this.formGroup.get("user_maxed_coupon"), "value")
            },
          ],

          is_active: is_active
        }
      ]
    };

    this.saving.emit(true);

    this.cmpMntService.insert(obj).pipe(
      finalize(() => {
        this.loading.submit = false;
        this.saving.emit(false);
        this.formGroup.enable();
        this.toggleDisable();
      }))
      .subscribe(
        (res: any) => {
          this.loading.submit = false;
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            if(!_.get(this.detail, "id")) {
              obj.data[0].id = _.get(res.success.results[0], 'details.object.id');
              obj.data[0].code = _.get(res.success.results[0], 'details.object.code');
            }
            
            obj.data[0].start_date = moment(obj.data[0].start_date).format('M/D/YYYY');
            obj.data[0].end_date = moment(obj.data[0].end_date).format('M/D/YYYY');

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    if (this.formGroup.touched) {
      for (let i in this.formGroup.controls) {
        this.formGroup.controls[i].markAsTouched();
      }
    }
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if (this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.saveChanges();
          } else {
            this.close(false);
          }
        })
    }
    else {
      this.close(false);
    }
  }

  computeSmsFee(ctrlLength: 0) {
    return (Math.ceil(ctrlLength / 160) * SMS_PRICE) > 0 ? (Math.ceil(ctrlLength / 160) * SMS_PRICE).toFixed(2) : 0;
  }

  getSmsMessage(data, key) {
    if(_.size(data) > 0) {
      return data.map(e => {
        if (_.get(e, "type") ==  _.toUpper(key)) {
          return e.message;
        }
      }).join('');
    }
    else {
      return this.defaultSMSMessages.map(e => { 
        if(e.type == _.toUpper(key)) {
          return e.message;
        }
      }).join('');
    }
  }

  getSmsId(data, key) {
    if(_.size(data) > 0) {
      return _.parseInt(data.map(e => {
        if (_.get(e, "type") ==  _.toUpper(key)) {
          return e.id;
        }
      }).join(''));
    }
    else {
      return 0;
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}